import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Spinner } from 'react-bootstrap';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import ToggleButton from 'react-bootstrap/ToggleButton';
import backArrow from '../../assets/img/backarrow.png';

import { addPatientFeedback } from '../../store/ai2';

const questionsMap = [
  {
    questionId: null,
    selectedAnswer: null,
    note: '',
  },
  {
    questionId: null,
    answerText: null,
    note: '',
  },
];

const preMedicareTimelineViewTitle = 'Pre Medicare timeline view';

export const ViewPatientModal = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { selectedTenancy, clinicianProfileStatus } = useSelector(
    (state) => state.clinicianProfile,
  );
  const questionItem = (selectedTenancy?.questionnaires || {}).find(
    (item) => item.title === preMedicareTimelineViewTitle,
  );
  const questions = questionItem ? questionItem.questions : [];
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (clinicianProfileStatus) {
      setIsLoading(false);
    }
  }, [clinicianProfileStatus]);

  // Modal State Controller
  const [modalshow, setModalShow] = useState(true);
  const handleClose = () => {
    setModalShow(false);
    props.sendToParent(false);
  };

  // Radio Options and Buttons
  const [radioButtons, setRadioButtons] = useState('');
  const [radioOptions, setRadioOptions] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);

  const onRadioOptionsChange = ({ target }) => {
    const { value } = target;
    questionsMap[1].questionId = questions[1].id;
    questionsMap[1].answerText = value;
    if (value != 'Other') questionsMap[1].note = '';
    setRadioOptions(value);
  };

  const onRadioButtonsChange = ({ target }) => {
    const { value } = target;
    questionsMap[0].questionId = questions[0].id;
    questionsMap[0].selectedAnswer = value === 'Yes' ? 'yes' : 'no';
    setRadioButtons(value);
  };

  const onInputChange = ({ target }) => {
    const { value } = target;
    questionsMap[1].note = value;
  };

  // disable submit button
  function SubmitButton() {
    if (radioOptions && radioButtons) {
      return (
        <button className="btn btnPrimary me-2" type="submit">
          Submit
        </button>
      );
    } else {
      return (
        <button className="btn btnPrimary me-2 disabled" type="submit" disabled>
          Submit
        </button>
      );
    }
  }

  // onSubmit

  const onSubmit = (event) => {
    event.preventDefault();
    setFormSubmitted(true);
    dispatch(
      addPatientFeedback(
        props.patient,
        selectedTenancy.questionnaires[0].id,
        questionsMap,
        'Completed',
        selectedTenancy,
      ),
    );
    navigate(`/patientDetails?access_token=${props.patient.access_token}`, {});
  };

  // onSkip (only on dev)
  const onSkip = (event) => {
    event.preventDefault();
    navigate(`/patientDetails?access_token=${props.patient.access_token}`, {});
  };

  useEffect(() => {
    if (!questionItem) {
      navigate(
        `/patientDetails?access_token=${props.patient.access_token}`,
        {},
      );
    }
  }, [questionItem]);

  if (questionItem) {
    return (
      <Modal
        show={modalshow}
        onHide={handleClose}
        animation={false}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        id="viewPatientModal"
      >
        <Form onSubmit={onSubmit}>
          <Modal.Header className="modal-header-transp">
            <Modal.Title>
              <button onClick={handleClose} className="btn simpleLink">
                <img src={backArrow} alt="backarrow" className="imgArrow" />
                Back to search
              </button>
              {process.env.REACT_APP_PROD !== 'true' ? (
                <button onClick={onSkip} className="btn simpleLink">
                  Skip
                </button>
              ) : null}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {isLoading && (
              <Container fluid>
                <div className="mySpinner" style={{ height: 100 }}>
                  <div>
                    <Spinner animation="border" role="status"></Spinner>
                    <span>
                      <br />
                      Loading...
                    </span>
                  </div>
                </div>
              </Container>
            )}
            {!isLoading && (
              <Container>
                {questions?.map((question, i) => (
                  <Row key={i} className="mb-3">
                    <Col lg={{ span: 3, offset: 2 }}>
                      <p>
                        <strong>
                          {question.question.replace(
                            '{first_name}',
                            props.patient.first_name.endsWith('s')
                              ? props.patient.first_name + "'"
                              : props.patient.first_name + "'s",
                          )}
                        </strong>
                      </p>
                    </Col>

                    {question.type === 'radio' && (
                      <Col>
                        <div>
                          {question.value.map((val, i) => (
                            <Form.Check
                              key={i}
                              type="radio"
                              name="radioOptions"
                              label={val}
                              id={val}
                              onChange={onRadioOptionsChange}
                              value={val}
                            />
                          ))}
                        </div>
                        {radioOptions === 'Other' && (
                          <div>
                            <input
                              type="text"
                              placeholder="Add a comment"
                              name="otherOptionText"
                              id="otherOptionText"
                              onChange={onInputChange}
                            />
                          </div>
                        )}
                      </Col>
                    )}
                    {question.type === 'range' && (
                      <Col>
                        <div className="mt-1 btn-radio">
                          <ButtonGroup>
                            {question.value.map((val, i) => (
                              <ToggleButton
                                key={i}
                                id={`radio-${i}`}
                                className="btn btnSecondary btn-long me-2"
                                type="radio"
                                name="radioButton"
                                value={val}
                                checked={radioButtons === val}
                                onChange={onRadioButtonsChange}
                              >
                                {val}
                              </ToggleButton>
                            ))}
                          </ButtonGroup>
                        </div>
                      </Col>
                    )}
                  </Row>
                ))}
              </Container>
            )}
          </Modal.Body>

          <Modal.Footer>
            <SubmitButton />
          </Modal.Footer>
        </Form>
      </Modal>
    );
  } else {
    return null;
  }
};
